import React, { useState } from 'react';
import { TextField, Button, Typography, Box, CircularProgress, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate, Link as RouterLink } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  backToLogin: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },
  error: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },
  success: {
    color: theme.palette.success.main,
    marginTop: theme.spacing(2),
    textAlign: 'center',
  }
}));

const ForgotPasswordPage = () => {
  const classes = useStyles();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const { resetPassword } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Veuillez entrer votre adresse email');
      return;
    }
    
    try {
      setError('');
      setMessage('');
      setLoading(true);
      await resetPassword(email);
      setMessage('Instructions envoyées ! Vérifiez votre boîte de réception.');
    } catch (error) {
      setError('Échec de l\'envoi des instructions. Vérifiez votre adresse email.');
      console.error('Reset password error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box width="100%">
      <Typography variant="h6" align="center" gutterBottom>
        Réinitialisation du mot de passe
      </Typography>
      
      <Typography variant="body2" align="center" gutterBottom>
        Entrez votre adresse email pour recevoir les instructions de réinitialisation.
      </Typography>
      
      <form className={classes.form} onSubmit={handleSubmit} noValidate>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="email"
          label="Adresse email"
          name="email"
          autoComplete="email"
          autoFocus
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        
        {error && (
          <Typography variant="body2" className={classes.error}>
            {error}
          </Typography>
        )}
        
        {message && (
          <Typography variant="body2" className={classes.success}>
            {message}
          </Typography>
        )}
        
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : 'Envoyer les instructions'}
        </Button>
        
        <Box className={classes.backToLogin}>
          <Link component={RouterLink} to="/login" variant="body2">
            Retour à la connexion
          </Link>
        </Box>
      </form>
    </Box>
  );
};

export default ForgotPasswordPage;
